import { FC } from "react";

import { useTranslate } from "../../../../../hooks/useTranslate";
import { SMSCodeStep } from "../../../../SMSCodeStep/SMSCodeStep";

import { DashboardTypography } from "@/dashboard-design-system/Typography";

export type UserPermissionMFAStepProps = {
  code: string;
  setCode: (code: string) => void;
  maskedPhoneNumber?: string;
  onResendCode: () => void;
  isResendDisabled: boolean;
  resendCountdownText: string;
  isLoadingResend: boolean;
  isDisabledSubmitCodeButton: boolean;
  isLoadingSubmitCode: boolean;
  onSubmitCode: () => void;
};

export const UserPermissionMFAStep: FC<UserPermissionMFAStepProps> = ({
  code,
  setCode,
  maskedPhoneNumber,
  onResendCode,
  isResendDisabled,
  resendCountdownText,
  isLoadingResend,
  isDisabledSubmitCodeButton,
  isLoadingSubmitCode,
  onSubmitCode,
}) => {
  const { t } = useTranslate();

  return (
    <SMSCodeStep
      description={
        <DashboardTypography variant="body2">
          {t("dashboard", "usersManagement.permissions.edit.mfaDescription", {
            maskedPhone: maskedPhoneNumber,
          })}
        </DashboardTypography>
      }
      code={code}
      setCode={setCode}
      submitButtonText={t("common", "Submit")}
      resendButtonText={resendCountdownText}
      isDisabledSubmitCodeButton={isDisabledSubmitCodeButton}
      isLoadingResendSms={isLoadingResend}
      isResendButtonDisabled={isResendDisabled}
      handleResendCode={onResendCode}
      isLoadingSubmitCode={isLoadingSubmitCode}
      onSubmitCode={onSubmitCode}
    />
  );
};
